import { useCallback, useMemo } from "react";
import { Button } from "react-bootstrap";
import { Link } from "react-router-dom";
import PropTypes from "prop-types";
import { isArray } from "lodash";

import { facilitatorCan } from "../../../helpers/authHelpers";
import { hasRole } from "../../../services/wp.user.service";
import { useAuth } from "../../../services/wp.auth.service";
import { useFacilitatorGlobal } from "../../../components/FacilitatorGlobalContext";
const CourseHeaderFacilitatorActions = ({
	event
}) => {
	const { user } = useAuth();
	const { duplicateEvent } = useFacilitatorGlobal();

	const canDuplicate = useMemo(() => (
		hasRole(["administrator", "staff"]) ||
		facilitatorCan(user, "duplicateOthersEvents") ||
		// eslint-disable-next-line no-extra-parens
		(facilitatorCan(user, "duplicateEvent") && event.facilitatorId && event.facilitatorId?.indexOf(parseInt(user.facilitatorId, 10)) !== -1)
	) && !!event.recurringClasses, [user?.facilitatorId, event]);
	const canViewRoster = useMemo(() => facilitatorCan(user, "viewOtherRosters") ||
		hasRole(["staff", "administrator"]) ||
		// eslint-disable-next-line no-extra-parens
		(isArray(event.facilitatorId) && event.facilitatorId?.indexOf(parseInt(user.facilitatorId, 10)) !== -1), [user?.facilitatorId]);

	const handleDupe = useCallback(() => duplicateEvent(event), [duplicateEvent, event]);

	return (
		<>
			{canDuplicate ? <Button onClick={handleDupe}>Duplicate Event</Button> : null}
			{canViewRoster ? <Button as={Link} to={`/facilitator/class/${event.id}`}>View Roster</Button> : null}
		</>
	);
};

CourseHeaderFacilitatorActions.propTypes = {
	event: PropTypes.shape({
		facilitatorId: PropTypes.arrayOf(PropTypes.number),
		id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
		recurringClasses: PropTypes.shape({})
	}).isRequired
};

export default CourseHeaderFacilitatorActions;
